import "./UserNotificationPreferencesDialog.scss";
import {IOnDestroy, IOnInit, IScope} from "angular";
import {ReplaySubject} from "rxjs";
import {UserNotificationPreferencesService} from "../../preferences/UserNotificationPreferencesService";
import {NotificationPreferenceState} from "../../preferences/models/NotificationPreferenceState";
import {MessageType} from "../../preferences/models/MessageType";

export class UserNotificationPreferencesDialogController implements IOnInit, IOnDestroy {

    public preferences$ = new ReplaySubject<Array<NotificationPreferenceState>>(1);

    public available = false;
    public blocked = false;
    public allowed = false;

    private readonly toggle$ = new ReplaySubject<MessageType>(1);
    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private $scope: IScope,
                       private userNotificationPreferencesService: UserNotificationPreferencesService) {
    }

    public $onInit(): void {
        this.watchPreferences();
        this.watchAvailableState();
        this.watchAllowedState();
        this.watchBlockedState();
        this.watchToggle();
    }

    private watchAvailableState() {
        this.userNotificationPreferencesService
            .available
            .takeUntil(this.destroyed$)
            .subscribe((available) => {
                this.$scope.$applyAsync(() => this.available = available);
            });
    }

    private watchAllowedState() {
        this.userNotificationPreferencesService
            .enabled
            .takeUntil(this.destroyed$)
            .subscribe((allowed) => {
                this.$scope.$applyAsync(() => this.allowed = allowed);
            });
    }

    private watchBlockedState() {
        this.userNotificationPreferencesService
            .blocked
            .takeUntil(this.destroyed$)
            .subscribe((blocked) => {
                this.$scope.$applyAsync(() => this.blocked = blocked);
            });
    }

    private watchPreferences() {
        this.userNotificationPreferencesService
            .preferences
            .takeUntil(this.destroyed$)
            .map((preferences) => preferences.list())
            .subscribe((preferences) => this.preferences$.next(preferences));
    }

    private watchToggle() {
        this.toggle$
            .withLatestFrom(this.userNotificationPreferencesService.preferences)
            .takeUntil(this.destroyed$)
            .map(([type, preferences]) => preferences.toggle(type))
            .subscribe((updated) => this.userNotificationPreferencesService.update(updated));
    }

    public enableNotifications() {
        this.userNotificationPreferencesService.subscribe();
    }

    public toggle(type: MessageType) {
        this.toggle$.next(type);
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
